import { toast } from "react-toastify";
import "./wsConfirmAlert.scss";
import React, { useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import { useNavigate } from "react-router-dom";
// import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";

const WsConfirmAlert = (props) => {
  const navigate = useNavigate();
  return (
    <div className="wscard-confirm-containor">
      <div className="close-icon-containor">
        <div className="close-icon-wrapper" onClick={props.onClose}>
          <CloseIcon className="close-icon" />
        </div>
      </div>
      <div className="Header">
        <h3>
          Add <span>{props.name}</span> to web Portal
        </h3>
        <div className="web-icon">
          <LanguageOutlinedIcon />
        </div>
      </div>

      <div className="bottom">
        <span
          onClick={() => {
            navigate("/adminuser/webportal", {
              state: { refNumber: props.refNumber },
            });
          }}
        >
          Ok <ArrowForwardIcon />
        </span>
      </div>
    </div>
  );
};

export default WsConfirmAlert;
